//import React from 'react';
import ReactDOM from 'react-dom/client';
import criarConfiguracao from 'esocial.web.react.lib/cjs/utils/configuracao';
import ConfiguracaoContext from 'esocial.web.react.lib/cjs/contexts/ConfiguracaoContext';
import App from './App';

import * as importedConfig from '../src/appsettings.json';
import * as importedMenu from '../src/navMenuList.json';
import * as importedBreadcrumb from '../src/breadcrumbsMap.json';

const configuracao = criarConfiguracao(importedConfig, importedMenu, importedBreadcrumb);
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    /*<React.StrictMode>*/
    <ConfiguracaoContext.Provider value={configuracao}>
        <App />
    </ConfiguracaoContext.Provider>
    /*</React.StrictMode>*/
);
